import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import LibraryService from './services/LibraryService'

export const getSearchPortfolio = createAsyncThunk(
  'portfolioInsights/common/getSearchPortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getSearchPortfolio(params)

      return res.success ? res : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const postCopyCompany = createAsyncThunk(
  'portfolioInsights/common/postCopyCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.postCopyCompany(params)
      return res.success ? res : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const postCreatePortfolio = createAsyncThunk(
  'portfolioInsights/common/postCreatePortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.postCreatePortfolio(params)

      return res.success
        ? res.data
        : rejectWithValue({
            loading: false,
            message: res.data.errors[0],
          })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }

      return rejectWithValue({
        loading: false,
        message: error.response.data.errors[0],
      })
    }
  },
)
